import { useEffect, useState } from 'react'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { sendGet } from 'hooks/use-fetch'
import { Box } from '@mui/material'
import DataTable from 'Components/Table/DataTable'
import { AccessRequestSearchOptions, type AccessRequestApprovalSearchCriteria } from 'Pages/AccessRequest/AccessRequestSearchOptions'
import { Column, ColumnSort, ColumnType, type RowData } from 'Components/Table/DataTable/DataTable.model'
import { FormatDateValue } from 'core/Utilities'
import { type PaginationProps, usePagination, type SearchCriteria } from 'hooks/use-pagination'
import { LargeCard } from 'Components/Cards/Large'

const requestedByColumn = new Column('userRequesting', 'Requested By')
const childNameColumn = new Column('childName', 'Child Name')
const requestDateColumn = new Column('requestDate', 'Request Date', ColumnType.CUSTOM)
requestDateColumn.customCellGenerator = row => {
  return <div>{FormatDateValue(row.requestDate)} </div>
}
const explanationColumn = new Column('explanation', 'Details')
const typeColumn = new Column('isTransfer', 'Request Type', ColumnType.CUSTOM)
typeColumn.customCellGenerator = row => {
  return <div>{row.isTransfer === true ? 'Transfer' : 'Access'} </div>
}

const statusColumn = new Column('approvedStatus', 'Status')
statusColumn.visibility = false
const siblingColumn = new Column('siblingOf', 'As Sibling Of', ColumnType.CUSTOM)
siblingColumn.customCellGenerator = row => {
  return <div>{row.siblingOf ?? 'None'}</div>
}

const columns = [requestedByColumn, childNameColumn, siblingColumn, requestDateColumn, explanationColumn, typeColumn, statusColumn]

export function MyAccessRequests (): JSX.Element {
  const [loading, setLoading] = useState(true)
  const [accessRequests, setAccessRequests] = useState<RowData[]>([])
  const [searchData, setSearchData] = useState<AccessRequestApprovalSearchCriteria>({
    approvalStatus: 'P',
    childName: '',
    userName: '',
    isdID: undefined
  })

  useEffect(() => {
    const loadData = async (): Promise<void> => {
      const { response, error } = await sendGet('/AccessRequest/MyRequests', {})
      setAccessRequests(response.data)
      if (error[0] === '' && response !== null) {
        setAccessRequests(response)
      }

      setLoading(false)
      handleSearch(searchData)
    }
    void loadData()
  }, [])

  const handleSearch = (newdata: AccessRequestApprovalSearchCriteria): void => {
    setSearchData(newdata)
    const fieldArray: SearchCriteria[] = []
    if (newdata.approvalStatus !== null) {
      fieldArray.push({
        field: 'approvedStatus',
        value: newdata.approvalStatus
      })
    }
    if (newdata.isdID !== undefined) {
      fieldArray.push({
        field: 'isdid',
        value: newdata.isdID.toString()
      })
    }
    if (newdata.childName !== '') {
      fieldArray.push({
        field: 'childName',
        value: newdata.childName
      })
    }
    if (newdata.userName !== '') {
      fieldArray.push({
        field: 'userRequesting',
        value: newdata.userName
      })
    }
    pagination.setSearchFields(fieldArray)
  }

  const paginationProps: PaginationProps<RowData> = {
    rows: accessRequests,
    initialSize: 5,
    pageSizeSteps: [5, 10]
  }
  const pagination = usePagination(paginationProps)

  return <LargeCard header='My Access Requests' headerClassName='info-box-header' sx={{ width: '100%', mt: 2 }} content={<>
    <AccessRequestSearchOptions current={searchData} onChange={handleSearch} />
    <Box sx={{ width: '100%', padding: '30px 20px', borderRadius: '16px', background: '#fff' }}>
      <DataTable
        page={pagination.page}
        hasCheckbox={false}
        name='accessRequestTable'
        columns={columns}
        rows={pagination.internalRows}
        totalRecords={pagination.recordCount}
        loading={loading}
        onSortChange={(col, sorts) => {
          pagination.onSortChange(col, sorts[0].order)
        }}
        onPageChange={pagination.handleChangePage}
        onRowsPerPageChange={pagination.handleChangeRowsPerPage}
        initialColumnSorts={[new ColumnSort('childName')]}
      />
    </Box>

  </>}
  />
}
